import React from 'react';
import { motion } from 'framer-motion';
import { Heart, Building2, Cloud, Globe } from 'lucide-react';
import { GlassShineCard } from './ui/glass-shine-card';
import { industryExperience } from '../data/siteData';

const industryIcons = {
  'healthcare-tech': Heart,
  'financial-services': Building2,
  'ai-saas': Cloud,
  'digital-products': Globe,
};

const IndustryExperience = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0 }
  };

  return (
    <section id="industry" className="industry-section">
      <div className="container">
        <motion.div
          className="section-header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2>Industry Experience</h2>
          <p>Domains where I've delivered engineering solutions</p>
        </motion.div>

        <motion.div
          className="industry-grid"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          {industryExperience.map((industry, index) => {
            const IconComponent = industryIcons[industry.id] || Globe;
            return (
              <motion.div
                key={industry.id}
                className="industry-card-item"
                variants={itemVariants}
                whileHover={{ 
                  scale: 1.02,
                  transition: { type: "spring", stiffness: 300, damping: 10 }
                }}
              >
                <GlassShineCard className="industry-card" mirrored={index % 2 === 1}>
                <div className="industry-icon">
                  <IconComponent size={24} aria-hidden="true" />
                </div>
                <h3>{industry.title}</h3>
                <p>{industry.description}</p>
                </GlassShineCard>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
};

export default IndustryExperience;
